import React, { useEffect, useState } from "react";
import { Drawer, Input, Select } from 'antd';
import style from "../style.module.scss"
import { FunctionsList, ToolsList, ToolsProps } from "../types";
import "../index.css"
import { ReactComponent as AddItem } from '../../../../../assets/svg/ai-agents/addItem.svg'
import { ReactComponent as RefetchIcon } from '../../../../../assets/svg/ai-agents/refreshIcon.svg'
import { VariablesLists } from "../variablesList";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Http } from "../../../../../helpers/axois";
const {TextArea} = Input
const {Option} = Select

export const ToolsDrawer = ({ visible, setVisible , toolsVariables, setToolsVariables, setToolsList, toolsList, editToolData, canEditAgents }: ToolsProps) => {
    const params: { appId?: string } = useParams()
    const appId = params.appId
    const versionId = useSelector((state: any) => {
        return appId && state.apps.appVersion[appId].versionId
    })
    const [errors, setErrors] = useState({name: "", description : "", function: ""})
    const [showAddFields, setShowAddFields] = useState<boolean>(true)
    const [functionsList, setFunctionsList] = useState<FunctionsList[]>([])
    const [showFields, setShowFields] = useState<boolean>(toolsVariables?.length > 0 ? true : false);
    const [formData, setFormData] = useState({
        id: editToolData.id || 0,
        name: editToolData.name || "",
        description: editToolData.description || "",
        function: editToolData.function || "",
    });

    const fetchFunctionsList = () => {
        Http.get(`/apps/${appId}/functions?versionId=${versionId}`).subscribe((serviceRes: any) => {
            const serverSideFunctions = serviceRes.filter((func: FunctionsList) => {
                return func.mode === "server"
            })
            setFunctionsList(serverSideFunctions)
        });
    }
    
    
    // Handle input change (updates formData)
    const handleInputChange = (key: string, value: any) => {
        setErrors((prevState) => {return {...prevState, [key]: ""}})
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const validate = () => {
        let hasError = false;
        const newErrors = { name: '', description: '', function: '' };

        if (!formData.name.trim()) {
            newErrors.name = 'Enter name';
            hasError = true;
        }

        if (formData.name && (!/^[a-zA-Z0-9_-]{1,64}$/.test(formData?.name || ''))){
            newErrors.name = 'Enter a valid name without special characters or spaces';
            hasError = true;
        }

        if (!formData.description.trim()) {
            newErrors.description = 'Enter description';
            hasError = true;
        }

        if (!formData.function) {
            newErrors.function = 'Select function';
            hasError = true;
        }

        setErrors(newErrors);
        return !hasError; // Return true if no errors
    };
    
    const handleSave = () => {
        if(!validate()){
            return
        }
        if(editToolData.name && editToolData.description && editToolData.function){

            setToolsList(toolsList.map((el: ToolsList, index: number) => {
                if(el.id === editToolData.id){
                    return {
                        ...el,
                        ...formData,
                        params: toolsVariables
                    }
                }else{
                    return el
                }
            }))
    
            setVisible(false)
            return
        }
        setToolsList([...toolsList, { ...formData, id: toolsList.length + 1, params: toolsVariables }])
        setVisible(false)
    }

    
    useEffect(() => {
        setShowAddFields(false)
        fetchFunctionsList()
    },[])

    return (
        <Drawer
            className="toolsDrawerHeader"
            width={520}
            title={
                <div className={style.toolsDrawerContainer} id="toolsDrawerHeader">
                    <span className={style.toolHeaderTitle}>Create Tool</span>

                    <div style={{display: "flex"}}>
                        <button style={{ width: 73 }} className={style.cancelButton} onClick={() => {
                            setVisible(false)
                            setToolsVariables([]);
                        }}>Cancel</button>
                        {canEditAgents && <button style={{ width: 73 }} className={style.saveAgentButton} onClick={() => {
                            handleSave()
                        }}>Save</button>}
                    </div>
                </div>}
            closable={false}
            onClose={() => { 
                setVisible(false); 
                setFormData({id: 0, 
                name: "",
                description: "",
                function: "",
            });
            setToolsVariables([]);
        }}
            visible={visible}
        >

            <div>
                <div style={{paddingTop: 10}}>
                    <span className={style.fieldHeader}>Name</span>
                    <Input
                        disabled={!canEditAgents}
                        className={style.createAgentName}
                        value={formData.name}
                        onChange={(e) => handleInputChange("name", e.target.value)}
                        style={{ height: 36, marginTop: 5, color: "#606060"}}
                        placeholder="Enter tool name"
                    />
                    {errors.name && <span className={style.errorMessage}>{errors.name}</span>}
                </div>
                <div style={{paddingTop: 20}}>
                    <span className={style.fieldHeader}>Description</span>
                    <TextArea
                        disabled={!canEditAgents}
                        className={style.createAgentName}
                        value={formData.description}
                        onChange={(e) => handleInputChange("description", e.target.value)}
                        style={{ height: 66, marginTop: 5, color: "#606060" }}
                        placeholder="Enter description"
                        autoSize={{ minRows: 3, maxRows: 5 }}
                    />
                    {errors.description && <span className={style.errorMessage}>{errors.description}</span>}
                </div>
                <div style={{ paddingTop: 20 }}>
                    <span className={style.fieldHeader}>Functions</span>
                    <Select
                        disabled={!canEditAgents}
                        value={formData.function || undefined}
                        className="functionsList"
                        dropdownClassName="agent-drop-down"
                        style={{width: "100%", height: 38, paddingTop: 5}}
                        placeholder="Select Functions"
                        onChange={(e) => handleInputChange("function", e)}
                    >
                        <Option key="create-function" value="">
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ 
                                    background: "#F1F8FF", 
                                    width: 400, 
                                    height: 32, 
                                    color: "#0466C8", 
                                    border: "0.75px dashed #0466C8", 
                                    textAlign: "center", 
                                    padding:5,
                                    fontSize: 14,
                                    fontWeight: 600,
                                    borderRadius: 8
                                    }}
                                    onClick={() => {
                                        window.open(`#/apps/list/${appId}/solo/functions/list`, "_blank")
                                    }}
                                    >Create Function</span>
                                <RefetchIcon onClick={() => {fetchFunctionsList()}}/>
                            </div>
                        </Option>
                        {functionsList.map((func) => {
                            return (
                                <Option key={func.id} value={func.name}>{func.name}</Option>
                            )
                        })}
                    </Select>
                    {errors.function && <span className={style.errorMessage}>{errors.function}</span>}
                </div>

                <div className={style.outputFormatContainer} style={{ marginTop: 20, borderBottom: showFields ? "10px solid #3461A21A" : 0}}>
                    <div className={style.outputHeader}>
                        <div className={style.outputHeaderText}>Tool Variables</div>
                        {canEditAgents && <div className={style.addFields}>
                            <div style={{ color: "#393939", fontSize: 14, cursor: "pointer", display: "flex" }}
                                onClick={() => {
                                    setShowFields(true)
                                    setShowAddFields(true)
                                }}
                            > <AddItem style={{ marginRight: 5 }} /> Add Field</div>
                        </div>}
                    </div>

                    {showFields && <VariablesLists
                        canEditAgents={canEditAgents}
                        variables={toolsVariables}
                        showAddFields={showAddFields}
                        hideAddFields={setShowAddFields}
                        setVariables={setToolsVariables}
                        hideFields={setShowFields} />}
                </div>
            </div>
        </Drawer>
    )
}